import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCachedAsset_Small, selectCachedAsset, selectCachedAssets_small } from "../../app/slices/AssetsSlice";
import { selectToken } from "../../app/slices/AuthenticationSlice";
import { selectCurrentOrganization } from "../../app/slices/UserSlice";
import { AssetService } from "../../services/AssetService";

/**
 * An asset with all its variants (one per language), as small thumbnails. Shares the small-preview
 * cache: GetAssetByGuid returns every variant, so the Bubbles column's thumbnail fetch already
 * holds the whole list.
 */
export const useAssetVariants = (assetId: string | undefined) => {
  const asset = selectCachedAsset(useSelector(selectCachedAssets_small), assetId);
  const orgId = useSelector(selectCurrentOrganization)?.id;
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  useEffect(() => {
    if (asset || !orgId || !assetId) return;
    let cancelled = false;
    AssetService.GetAssetByGuid(orgId, token, assetId, false, "small").then((fetched) => {
      if (fetched && !cancelled) dispatch(addCachedAsset_Small(fetched));
    });
    return () => {
      cancelled = true;
    };
  }, [asset, orgId, token, assetId, dispatch]);

  return asset;
};
